// `AssessmentBuilder.Events` must be defined in a standalone module so that
// `import.meta.glob({ eager: true })` of `./views/**/*` can rely on it at
// module top-level — defining it inside `index.js` would execute too late,
// after the view modules have already been hoisted.

window.AssessmentBuilder ??= {};

window.AssessmentBuilder.Events = {
  Relation: {
    changed: "relation-changed",
  },
  AssessmentNavigator: {
    introSelected: "assessmentNavigator-introSelected",
    introUnselected: "assessmentNavigator-introUnselected",
    submitterInfoSelected: "assessmentNavigator-submitterInfoSelected",
    submitterInfoUnselected: "assessmentNavigator-submitterInfoUnselected",
    questionSelected: "assessmentNavigator-questionSelected",
    questionUnselected: "assessmentNavigator-questionUnselected",
    completionPageSelected: "assessmentNavigator-completionPageSelected",
    completionPageUnselected: "assessmentNavigator-completionPageUnselected",
  },
  Intro: {
    clicked: "intro-clicked",
  },
  SubmitterInfo: {
    clicked: "submitter-info-clicked",
  },
  Question: {
    clicked: "question-clicked",
    removeClicked: "question-removeClicked",
  },
  CompletionPage: {
    clicked: "completionPage-clicked",
    removeClicked: "completionPage-removeClicked",
  },
  Response: {
    removeClicked: "response-removeClicked",
  },
};
